import { render } from "./GerenciamentoRepresentante.vue?vue&type=template&id=38b652be&scoped=true"
import script from "./GerenciamentoRepresentante.vue?vue&type=script&lang=js"
export * from "./GerenciamentoRepresentante.vue?vue&type=script&lang=js"

import "./GerenciamentoRepresentante.vue?vue&type=style&index=0&id=38b652be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b652be"]])

export default __exports__